/* global angular */

var ngModule = angular.module('trends');

ngModule.directive('urlShare', ['$popover', '$alert', 'BrowserDetector',
    function ($popover, $alert, BrowserDetector) {
        return {
            restrict: 'A',
            scope: true, 
            link: function (scope, element, attrs) {
                /* 
                 * Get the URL from the attribute provided when the directive is used.
                 * This is evaluated in case a method to get the URL is provided.
                 * (When providing a string as the attribute, escape with quotes)
                 */
                scope.link = function() {
                    return scope.$eval(attrs.urlShare);
                };

                var pop = $popover(element, {
                    scope: scope,
                    placement: 'bottom',
                    autoClose: true,
                    contentTemplate: '/trends/partials/url_share/',
                    container: 'body'
                });

                /* ### TODO: Translate alert contents when needed ### */
                var alrt = $alert({
                    title: 'Link Copied',
                    content: 'The URL has been copied to your clipboard.',
                    type: 'info',
                    container: 'body',
                    dismissable: false,
                    show: false,
                    duration: 3
                });

                // popover's $isShown is subject to race condition so track whether popover is shown  manually
                var popShowing = false;

                // Add icons to link
                element.prepend('<span class="icon PD-link"></span>');
                element.append('<span class="icon PD-down-arrow"></span>');

                element.bind('click', function () {
                    if(!popShowing) {
                        pop.$promise.then(pop.show);
                        element.children('.PD-down-arrow').addClass('rotated');
                        popShowing = true;
                    }
                });

                /* Copy the application URL to the clipboard */
                scope.copyUrl = function () {
                    pop.$element.find('input').select();
                    document.execCommand('copy');
                    alrt.show();
                };

                /* The copy to clipboard button should only show in browsers that support it */
                scope.isCopySupported = function () {
                    var browser = BrowserDetector.getBrowserInfo();

                    return browser.name === 'Chrome' ||
                        browser.name === 'Firefox' && browser.version >= 41 ||
                        (browser.name === 'MSIE' || browser.name === 'IE') && browser.version >= 8;
                };

                /* Pre-select the text box contents when popover opens for quick copying */
                scope.$on('tooltip.show', function() {
                    pop.$element.find('input').select();
                });

                /* Return flipped icon to original state when hiding popover */
                scope.$on('tooltip.hide.before', function () {
                    if (popShowing) {
                        element.children('.PD-down-arrow').removeClass('rotated');
                        popShowing = false;
                    }
                });
            }
        };
    }
]);
